import React from "react";
import { Card, CardBody } from "reactstrap";
import { Link } from "gatsby";
import PaginationBar from "../Common/Pagination";

const Item = ({ industry }) => {
  return (
    <div className="col-lg-12 col-sm-12 mb-4 pb-2">
      <Card className="single-blog-post rounded border-0 blog-shadow overflow-hidden">
        <div className="row align-items-center no-gutters">
          <div className="col-md-3">
            <img
              src={industry.image.childImageSharp.fixed.src}
              style={{
                aspectRatio: "16 / 9",
              }}
              className="img-fluid"
              alt="大任人力资源管理系统"
            />
            <div className="overlay bg-dark"></div>
            <div className="author">
              <small className="text-light user d-block">
                <i className="mdi mdi-account"></i> {industry.autor}
              </small>
              <small className="text-light date">
                <i className="mdi mdi-calendar-check"></i> {industry.date}
              </small>
            </div>
          </div>

          <div className="col-md-8">
            <CardBody className="content">
              <h6>
                <Link to={`/industry/${industry.strapiId}`} className="card-title title text-dark">
                  {industry.title}
                </Link>
              </h6>
              <div className="industryInfo">
                <p className="text-muted mb-0">{industry.desc}</p>
              </div>
              <div className="post-meta d-flex justify-content-between mt-3">
                <ul className="list-unstyled mb-0">
                  <li className="list-inline-item mr-2 mb-0">
                    <Link to="#" onClick={e => e.preventDefault()} className="text-muted like">
                      <i className="mdi mdi-heart-outline mr-1"></i>
                      {industry.date}
                    </Link>
                  </li>
                </ul>
                <Link to={`/industry/${industry.strapiId}`} className="text-muted readmore">
                  详情 <i className="mdi mdi-chevron-right"></i>
                </Link>
              </div>
            </CardBody>
          </div>
        </div>
      </Card>
    </div>
  );
};

const CategoryTab = ({ tabs }) => {
  return (
    <div className="courses-details-desc m-0 mb-5">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        {tabs.map((tab, index) => (
          <li key={index} className="nav-item">
            {tab}
          </li>
        ))}
      </ul>
    </div>
  );
};

const IndustryList = ({ industries, totalPage, curPage, baseUrl }) => {
  return (
    <div className="blog-details-desc">
      <div className="row">
        {industries.map((industry, key) => (
          <Item key={`${industry.slug}-${key + 1}`} industry={industry} />
        ))}
      </div>
      <PaginationBar baseUrl={baseUrl} curPage={curPage} maxPage={totalPage} />
    </div>
  );
};

export default IndustryList;
